import { Action, createReducer, on } from '@ngrx/store';
import { User } from './auth.models';
import * as AuthActions from './auth.actions';
import { actionButton } from '@aws-amplify/ui';
import { state } from '@angular/animations';

export const authFeatureKey = 'auth';

export interface State {
  authenticating: boolean;
  authenticatingError: string;
  authenticatedUser: User;

  signinUp: boolean;
  authState: string;
  authMessage: string;
  signinUpError: string;
}

export const initialState: State = {
  authenticating: false,
  authenticatedUser: null,
  authenticatingError: null,

  signinUp: false,
  authState: null,
  authMessage: null,
  signinUpError: null,
};


export const reducer = createReducer(
  initialState,

  on(AuthActions.authenticateUser, state => {
    return {
      ...state,
      authenticating: true,
      authenticatedUser: null,
      authenticatingError: null
    }
  }),
  on(AuthActions.authenticateUserSuccess, (state, action) => {
    return {
      ...state,
      authenticatedUser: action.user,
      authenticating: false
    }
  }),
  on(AuthActions.authenticateUserFailure, (state, action) => {
    return {
      ...state,
      authenticating: false,
      authenticatedUser: null,
      authenticatingError: action.error
    }
  }),
  on(AuthActions.authenticateUserPrecheck, (state) => {
    return {
      ...state,
      authenticating: true,
      authenticatingError: null
    }
  }),
  on(AuthActions.logoutUser, () => {
    return initialState
  }),
  on(AuthActions.signUpUser, (state) => {
    return {
      ...state,
      signinUp: true,
      signinUpError: null
    }
  }),
  on(AuthActions.signUpUserSuccess, (state, action) => {
    return {
      ...state,
      signinUp: false,
      authMessage: action.message,
      authState: action.authState
    }
  }),
  on(AuthActions.signUpUserFailure, (state, action) => {
    return {
      ...state,
      signinUp: false,
      signinUpError: action.error,

    }
  }),
  on(AuthActions.signUpUserFailure, (state, action) => {
    return {
      ...state,
      signinUp: false,
      signinUpError: action.error
    }
  }),
  on(AuthActions.logoutUser, () => {
    return {
      ...state,
      authenticating: false,
      authenticatedUser: null,
      authenticatingError: null,

      signinUp: false,
      authState: null,
      authMessage: null,
      signinUpError: null
    };
  })
);

